import { useState, useEffect } from "react";
import { TiDelete } from "react-icons/ti";
import { toast } from "react-toastify";
import {
  Avatar,
  Button,
  Typography,
  Grid,
  Paper,
  Box,
  TextField,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Tooltip,
  Modal,
} from "@mui/material";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import AxiosInstance from "../../../apis/AxiosInstance";
import { useNavigate } from "react-router-dom";
import { AiFillCloseSquare } from "react-icons/ai";

const UpdateGdEvolutionInTree = ({ studentData, groupIdx }) => {
  let navigate = useNavigate();

  const [open, setOpen] = useState(false);
  // const handleOpen = () => setOpen(true);
  // const handleOpen = () => {
  //   if (studentData.validate) {
  //     setOpen(true);
  //   } else {
  //     toast.warning(
  //       "You can't Update GD Evaluation as GD time to edit is Crossed"
  //     );
  //   }
  // };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  let [status, setStatus] = useState("");
  let [statusOption, setStatusOption] = useState(null);

  //for appointmentStatus
  useEffect(() => {
    let fetchData = async () => {
      let appStatus = await AxiosInstance.get(`/gd_status`);
      let finalAppStatus = appStatus.data.data;
      setStatusOption(finalAppStatus);
    };
    if (open) {
      fetchData();
    }
  }, [open]);

  const randomKey =
    studentData?.gd_marks && Object.keys(studentData.gd_marks).length > 0
      ? Object.entries(studentData.gd_marks)
      : [];
  const gdMarksFields =
    randomKey.length > 0
      ? randomKey.filter((e) => {
          return e[1] && !Array.isArray(e[1]) && Object.keys(e[1]).length > 0;
        })
      : [];
  const obj = {};
  const obj2 = {};
  if (gdMarksFields.length > 0) {
    gdMarksFields.forEach((e) => {
      if (e[0] == "comment") {
        obj["comment"] = e[1];
      } else if (e[0] == "gd_status") {
        obj["gd_status"] = Number(Object.keys(e[1])[0]);
      } else {
        obj2[e[0]] = e[1];
      }
    });
  }
  const [criteriaFields, setCriteriaFields] = useState(
    gdMarksFields.length > 0 ? obj : null
  );
  const [otherFields, setOtherFields] = useState(
    Object.keys(obj2).length > 0 ? obj2 : null
  );

  const resetAppStatus = async (e) => {
    e.preventDefault();
    setStatus("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      group_id: Number.parseInt(groupIdx),
      student_id: [studentData.id],
      gd_evaluation: Object.keys(otherFields).reduce((acc, key) => {
        acc[key] = {
          scored_marks: parseFloat(otherFields[key].scored_marks),
          take: true,
        };
        return acc;
      }, {}),
      comment: criteriaFields.comment,
      status: criteriaFields.gd_status,
    };

    try {
      await AxiosInstance.post(`/gd_evaluation`, payload)
        .then((response) => {
          toast.success(response.data.message);

          if (response.status === 200) {
            setTimeout(() => {
              navigate("/tree_roundsto_shortlist");
              setOpen(false);
              window.location.reload();
            }, 1000);
          }
        })
        .catch((error) => {
          console.log("error", error);
          if (error.response) {
            toast.error(error.response.data);
          } else {
            toast.error(error);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  const paperStyle = {
    padding: 20,
    gap: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "10px auto",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "auto",
    maxHeight: "80vh",
    overflowY: "auto",
  };

  const avatarStyle = { backgroundColor: "#081F37" };

  const gridContainer = {
    margin: "0 auto",
    gap: 20,
  };

  return (
    <div>
      <Tooltip title="Update GD Result">
        <Button
          size="small"
          onClick={handleOpen}
          // sx={{
          //   "&:hover": { background: "#DBDFFD" },
          //   color: studentData.validate == false ? "#111" : "#fff",
          //   background: studentData.validate == false ? "#DC8686" : "#AC87C5",
          //   cursor: studentData.validate == false ? "not-allowed" : "pointer",
          //   "&:hover": {
          //     color: studentData.validate == false ? "#111" : "#fff",
          //     background: studentData.validate == false ? "#DC8686" : "#392467",
          //   },
          // }}
          sx={{
            color: "#111",
            background: "#DC8686",
            "&:hover": {
              color: "#fff",
              background: "#392467",
            },
          }}
        >
          Update Result
        </Button>
      </Tooltip>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Grid>
          <Grid xs={12} item container style={gridContainer} align="center">
            <Paper elevation={10} style={paperStyle}>
              <Grid align="center" item>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <AiFillCloseSquare
                    fontSize={30}
                    onClick={handleClose}
                    color="#FC2947"
                    style={{ cursor: "pointer" }}
                  />
                </Box>
                <Avatar style={avatarStyle}>
                  <GroupAddIcon />
                </Avatar>
                <h2>Update GD Evaluation</h2>
                <br />
              </Grid>
              <form action="" onSubmit={handleSubmit}>
                <Grid>
                  <div>
                    {criteriaFields ? (
                      <div>
                        {otherFields &&
                          Object.keys(otherFields).length > 0 &&
                          Object.entries(otherFields).map((ex) => {
                            return (
                              <>
                                <Typography
                                  variant="h6"
                                  style={{
                                    textAlign: "left",
                                    fontWeight: "bold",
                                    marginBottom: "20px",
                                    textTransform: "capitalize",
                                    textDecoration: "underline",
                                    fontSize: "medium",
                                  }}
                                >
                                  {ex[0].split("_").join(" ")}
                                </Typography>
                                <Grid
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <Grid>
                                    <TextField
                                      label="Scored Marks"
                                      inputProps={{
                                        minLength: 1,
                                        maxLength: 5,
                                      }}
                                      name={`${ex[0]}_marks`}
                                      value={ex[1].scored_marks}
                                      onChange={(e) => {
                                        const inputValue = e.target.value;
                                        if (/^\d*\.?\d*$/.test(inputValue)) {
                                          setOtherFields({
                                            ...otherFields,
                                            [ex[0]]: {
                                              ...otherFields[ex[0]],
                                              scored_marks: e.target.value,
                                            },
                                          });
                                        }
                                      }}
                                      onInput={(e) => {
                                        e.preventDefault();
                                        const inputValue =
                                          e.target.value.replace(
                                            /[^0-9.]/g,
                                            ""
                                          );
                                        setOtherFields(inputValue);
                                      }}
                                    />
                                  </Grid>
                                  <Grid>
                                    <TextField
                                      label="Total Marks"
                                      name={`${ex[0]}_total_marks`}
                                      value={ex[1].marks}
                                      disabled
                                    />
                                  </Grid>
                                  <Grid>
                                    <TextField
                                      label="Percentage"
                                      name={`${ex[0]}_percentage`}
                                      disabled
                                      value={ex[1].percentage}
                                    />
                                  </Grid>
                                </Grid>
                                <br />
                                <hr />
                              </>
                            );
                          })}
                        <Grid
                          item
                          sm={12}
                          id="refreshTool"
                          style={{ position: "relative", marginTop: "3%" }}
                        >
                          <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">
                              Status
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              required
                              sx={{ textAlign: "left" }}
                              value={criteriaFields.gd_status}
                              label="Status"
                              onChange={(e) => {
                                setCriteriaFields({
                                  ...criteriaFields,
                                  ["gd_status"]: e.target.value,
                                });
                              }}
                            >
                              {statusOption === null ? (
                                <MenuItem>No data Available</MenuItem>
                              ) : (
                                statusOption.map((e) => {
                                  return (
                                    <MenuItem
                                      value={e.id}
                                      key={"status" + e.id}
                                    >
                                      {e.name}
                                    </MenuItem>
                                  );
                                })
                              )}
                            </Select>
                            {status !== "" ? (
                              <Tooltip title="Clear Status">
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "9px",
                                    left: "380px",
                                    color: "#CC7351",
                                    cursor: "pointer",
                                  }}
                                >
                                  <TiDelete
                                    fontSize={24}
                                    title="Reset Status"
                                    onClick={resetAppStatus}
                                  />
                                </div>
                              </Tooltip>
                            ) : null}
                          </FormControl>
                        </Grid>
                        <Grid style={{ marginTop: "3%" }}>
                          <TextField
                            label="Comment"
                            multiline
                            maxRows={5}
                            fullWidth
                            name="comment"
                            value={criteriaFields.comment}
                            onChange={(e) => {
                              setCriteriaFields({
                                ...criteriaFields,
                                ["comment"]: e.target.value,
                              });
                            }}
                          />
                        </Grid>
                      </div>
                    ) : (
                      <Typography variant="body1">No Data available</Typography>
                    )}
                  </div>
                </Grid>
                <Grid
                  xs={12}
                  item
                  spacing={2}
                  sx={{ mt: 5, mb: 2 }}
                  style={{
                    textAlign: "center",
                    padding: "5px",
                  }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    style={{ width: "20%" }}
                  >
                    Submit
                  </Button>
                </Grid>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Modal>
    </div>
  );
};

export default UpdateGdEvolutionInTree;
